import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { ReactComponent as WhatsappIcon } from "../../../images/icons/whatsapp.svg";
import "../Whatsapp/Whatsapp.css";
const whatsAppNumber = "5511958282944";
const message = "Olá, gostaria de mais informações!";
export const whatsAppLink = `https://wa.me/${whatsAppNumber}?text=${encodeURIComponent(message)}`;

function WhatsappButton() {
  const [isVisible, setIsVisible] = useState(false); // começa invisível

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollPosition = window.innerHeight + scrollTop;
      const pageHeight = document.documentElement.scrollHeight;

      const isAtTop = scrollTop === 0;
      const isAtBottom = scrollPosition >= pageHeight - 50;

      if (window.innerWidth < 768) {
        console.log("caiu aqui 1");
        setIsVisible(!isAtTop && !isAtBottom);
        
      } else {
        console.log("caiu aqui 2");
        setIsVisible(!isAtBottom);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  return (
    isVisible && (
      <a href={whatsAppLink} target="_blank" rel="noopener noreferrer">
        <Button className="whatsapp-button position-fixed bottom-0 end-0 m-4">
          <WhatsappIcon title="Fale comigo no Whatsapp" alt="Ícone Whatsapp" style={{ fill: "#FFFF", width: '25px', height: '25px', marginRight: '10px' }} className="whatsapp-icon" />
        </Button>
      </a >
    )
  );
}

export default WhatsappButton;
